import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import * as actions from '../../../actions';
import styled from 'styled-components';
import { Form, Input, Icon, Button } from 'antd';
import LeftRowShipping from './LeftRowShipping';
import { isEmpty } from '../../../util/isEmpty';

let id = 1;

const StyledTotalSummary = styled.span`
  padding: 0px 10px 0px 0px;
  font-size: 13px;
  width: 250px;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  color: #0093ee;
`;

/**
 * @component
 * @category Form Page
 * @subcategory LCL/AIR Tab
 * @name MainContentFieldSet
 * @description It's the LCL/AIR PALLETS / BOXES / CRATES shipping component
 * <br> <br>
 * **Example**
 * ```js
 *   <MainContentFieldSet />
 * ```
 */
class MainContentFieldSet extends React.Component {
  state = {
    initKeys: [0],
  };
  componentDidMount = () => {
    //get old rows
    const { boxPallet } = this.props;
    if (!isEmpty(boxPallet)) {
      let keys = Object.keys(boxPallet);
      keys = keys.map((key) => boxPallet[key] && Number(key));
      // console.log('new non-fcl left row shipping keys:', keys);
      this.setState({ initKeys: keys });
    }
  };

  /**
   * @description when a lcl/air box/pallet load is removed, this method is invoked
   * <br> <br>
   * **remove(k) -> {void}**
   * <br><br>
   * **Parameters:**
   * | Name          | Type          | Description  |
   * | :------------ |:------------- | :------------|
   * | k             | number        | `id`/`key` of the load e.g. `3` |

   * Returns: Type: void
   */
  remove = (k) => {
    const { form } = this.props;
    const keys = form.getFieldValue('keys');
    // We need at least one passenger
    if (keys.length === 1) {
      return;
    }

    form.setFieldsValue({
      keys: keys.filter((key) => key !== k),
    });

    // migratated from non-fcl LeftRowShipping to here
    this.props.deleteLclBoxPallet(k);
  };

  /**
   * @description when a lcl/air box/pallet load is added, this method is invoked
   * <br> <br>
   * **add() -> {void}**
   * <br><br>
   * Returns: Type: void
   */
  add = () => {
    const { form } = this.props;
    const keys = form.getFieldValue('keys');
    const nextKeys = keys.concat(id++);
    // important! notify form to detect changes
    form.setFieldsValue({
      keys: nextKeys,
    });
  };

  render() {
    const { getFieldDecorator, getFieldValue } = this.props.form;
    const { initKeys } = this.state;
    // console.log('initKeys: ', initKeys);

    getFieldDecorator('keys', { initialValue: initKeys });
    const keys = getFieldValue('keys');
    // console.log("keys: ", keys);

    const formItems = keys.map((k, index) => (
      <Form.Item required={false} key={k}>
        <div
          style={{
            width: '100%',
            height: 'auto',
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
          }}
          className="testO1"
        >
          <div className="testBla1 ">
            {getFieldDecorator(`names[${k}]`, {
              rules: null,
            })(
              <div {...{ form: this.props.form }}>
                <LeftRowShipping rowId={k} />
              </div>
            )}
          </div>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
            }}
            className="testR1"
          >
            {keys.length > 1 ? (
              <Icon
                type="close-circle"
                style={{ color: 'red' }}
                onClick={() => this.remove(k)}
                className="testR1"
              />
            ) : null}
          </div>
        </div>
      </Form.Item>
    ));
    return (
      <Form className="my-leftMainContent-form">
        <div className="testO1"> {formItems}</div>
        <div style={{ height: '42px' }}>
          <hr
            style={{
              borderColor: '#ffdfac',
              height: '2px',
              border: 0,
              borderTop: '1px solid rgb(197, 217, 232)',
            }}
          />
          <Form.Item>
            <div
              style={{
                height: '40px',
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
              }}
              className="testO1"
            >
              <span
                onClick={this.add}
                style={{
                  width: '100px',
                  cursor: 'pointer',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                }}
                className="testR1"
              >
                <span>
                  <Icon
                    type="plus-circle"
                    theme="filled"
                    style={{ color: '#0093ee' }}
                  />
                  <span
                    style={{
                      fontSize: '13px',
                      color: '#627b93',
                      width: '50px',
                      marginLeft: '10px',
                    }}
                  >
                    Add load
                  </span>
                </span>
              </span>

              <StyledTotalSummary className="testR1">
                <span>{this.props.loadSummaryText || ''}</span>
              </StyledTotalSummary>
            </div>
          </Form.Item>
        </div>
      </Form>
    );
  }
}

MainContentFieldSet.propTypes = {
  /**
   * summary text under 'search and book' button.
   */
  loadSummaryText: PropTypes.string,
  /**
   * lcl box/pallet data
   */
  boxPallet: PropTypes.object,
};

const LeftMainContent = Form.create({ name: 'form_shipping_right' })(
  MainContentFieldSet
);

const mapStateToProps = (state) => {
  return {
    loadSummaryText: state.form.loadSummaryText,
    boxPallet: state.form.lclAirShipping.boxPallet,
  };
};

export default connect(mapStateToProps, actions)(LeftMainContent);
